import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Separator } from '@change-corgi/design-system/components/content';
import { Html } from '@change-corgi/design-system/html';
import { Box } from '@change-corgi/design-system/layout';
import { Heading, Text } from '@change-corgi/design-system/typography';

import { PetitionMedia } from './components/PetitionMedia';
import { PsfOnlyShareActions } from './components/PsfOnlyShareActions';
import { ShareActions } from './components/ShareActions';
import { ShareFeed } from './components/ShareFeed';
import { usePageBody } from './hooks/usePageBody';

export function PageBody() {
	const {
		data: { heading, subHeading, warning, shareFeed, isPsfOnlyShare },
	} = usePageBody();

	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: ['1fr', shareFeed.showOnDesktop ? '1fr 42%' : null],
				gap: 24,
			}}
		>
			<Box
				backgroundColor="primary-white"
				sx={{
					boxShadow: '0 2px 3px 0 rgba(54, 49, 53, 0.2)',
					borderRadius: 'standard',
					overflow: 'hidden',
				}}
			>
				<PetitionMedia />
				<Box px={[16, 48]} pt={[16, 48]} pb={48}>
					<Box data-qa="description">
						<Heading as="h1" size={['h2', 'h1']} mb={16}>
							{heading}
						</Heading>
						<Text as="div" size="large">
							<Html html={subHeading} noContentStyles />
						</Text>
						{warning && (
							<Text as="div" size="large" mt={16} data-qa="warning">
								<Html html={warning} noContentStyles />
							</Text>
						)}
					</Box>
					<ClientRender>
						{() => (isPsfOnlyShare ? <PsfOnlyShareActions mt={32} /> : <ShareActions mt={32} />)}
					</ClientRender>
				</Box>
				{shareFeed.showOnMobile && (
					<Box
						sx={{
							display: ['block', 'none'],
						}}
						mt={16}
					>
						<Separator
							sx={{
								width: '55%',
								mx: 'auto',
							}}
						/>
						<ShareFeed
							items={shareFeed.items}
							animationStartSize={2}
							sx={{
								height: 200,
							}}
							data-qa="share-feed-mobile"
						/>
					</Box>
				)}
			</Box>
			{shareFeed.showOnDesktop && (
				<ShareFeed
					items={shareFeed.items}
					animationStartSize={10}
					backgroundColor="primary-white"
					sx={{
						display: ['none', 'block'],
						boxShadow: '0 2px 3px 0 rgba(54, 49, 53, 0.2)',
						borderRadius: 'standard',
						height: '100%',
					}}
					data-qa="share-feed-desktop"
				/>
			)}
		</Box>
	);
}
